import { Service } from "./interfaces"

export interface RecommendedServices {
  for_triggers: Array<{ module_name: string }>
  for_queries: Array<{ module_name: string }>
  for_actions: Array<{ module_name: string }>
}

// Warms the browser cache for the service selector: the tile images of the
// recommended services (triggers, queries, and actions), as low-priority
// prefetch links. Links already in the document are skipped, so calling
// again (or remounting) inserts nothing new.
export const prefetchRecommendedServiceImages = (services: Array<Service>, recommended?: RecommendedServices) => {
  const servicesByModuleName = new Map(services.map(s => [s.module_name, s]))

  const urls = new Set(
    [...(recommended?.for_triggers ?? []), ...(recommended?.for_queries ?? []), ...(recommended?.for_actions ?? [])]
      .map(({ module_name }) => servicesByModuleName.get(module_name)?.image)
      .filter((image): image is string => !!image),
  )

  urls.forEach(href => {
    if (document.querySelector(`link[rel="prefetch"][href="${CSS.escape(href)}"]`)) return

    const link = document.createElement("link")
    link.rel = "prefetch"
    link.setAttribute("as", "image")
    link.href = href
    document.head.appendChild(link)
  })
}
